var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1601 7.48519L7.62724 3.15163L4.6924 36.697L17.2333 29.4766L29.1842 38.6585L39.7546 29.3312L53.9148 44.5786L57.1601 7.48519ZM53.7597 46.3514L39.663 31.1725L17.3899 50.8261L53.095 53.9499L53.7597 46.3514ZM16.044 50.7084L15.8182 50.4525L28.1757 39.5483L17.1281 31.0604L4.55207 38.301L3.5621 49.6163L16.044 50.7084ZM5.62727 0.768156L2.36676 38.036L2.19985 38.1321L2.33744 38.3711L1.37038 49.4246L1.37031 49.4246L0.910111 54.6847L54.8264 59.4018L54.8264 59.4015L54.8265 59.4015L59.5436 5.48522L5.62727 0.768156ZM24.564 16.5596C24.3098 19.4647 21.7488 21.6137 18.8437 21.3595C15.9386 21.1053 13.7896 18.5443 14.0437 15.6392C14.2979 12.7341 16.859 10.5851 19.7641 10.8392C22.6692 11.0934 24.8182 13.6545 24.564 16.5596ZM25.879 16.6746C25.5613 20.306 22.36 22.9922 18.7286 22.6745C15.0973 22.3568 12.411 19.1555 12.7287 15.5241C13.0464 11.8928 16.2478 9.20651 19.8791 9.52421C23.5105 9.84192 26.1967 13.0433 25.879 16.6746Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/image-upload.47b2b9f6774d0d98b71924f37ebd7ac9.svg";
export { ForwardRef as ReactComponent };